import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../services/axiosInstance";
import { setCountryId } from "../slices/authSlice";
// Get profile details
export const getProfileDetail = createAsyncThunk(
  "profile/getProfileDetail",
  async (_, { dispatch, rejectWithValue }) => {
    try {
      const res = await axiosInstance.get("/get-user-detail");
      if (!res.data.success) {
        return rejectWithValue(res.data.message);
      }
      // console.log("The res data of profile details is :", res.data);
      const country_id = res.data.data.country_id;
      // console.log("The id is :", country_id);
      return res.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Something went wrong",
      );
    }
  },
);
export const addOrUpdateProvider = createAsyncThunk(
  "profile/addOrUpdateProvider",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await axiosInstance.post(
        "/add-or-update-user-detail",
        payload,
      );
      if (!res.data.success) {
        return rejectWithValue(res.data.message);
      }
      // console.log("The res data of profile details is :", res.data);
      return res.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Something went wrong",
      );
    }
  },
);

export const changePassWord = createAsyncThunk(
  "profile/changePassWord",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await axiosInstance.post("/change-password", payload);
      if (!res.data.success) {
        return rejectWithValue(res.data.message);
      }
      // console.log("The res of changing password is :", res.data);
      return res.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Something went wrong",
      );
    }
  },
);

export const deleteAcc = createAsyncThunk(
  "profile/deleteAcc",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await axiosInstance.post("/delete-account", payload);

      if (!res.data.success) {
        return rejectWithValue(res.data.message);
      }
      // console.log("The res for acc delete is :", res.data);
      return res.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Something went wrong",
      );
    }
  },
);

export const getQrCOde = createAsyncThunk(
  "profile/getQrCode",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await axiosInstance.post("/profile-with-qr", payload);
      return res.data;
    } catch (err) {
      return rejectWithValue(
        err?.message?.data || err?.message || err || "Something went wrong",
      );
    }
  },
);

export const getInquirys = createAsyncThunk(
  "profile/getInquirys",
  async ({ page = 1 }, { rejectWithValue }) => {
    try {
      const res = await axiosInstance.get("/list-customer-inquiry", {
        params: {
          page,
        },
      });
      return res.data;
    } catch (err) {
      return rejectWithValue(
        err?.response?.data || err?.message || err || "Something went wrong",
      );
    }
  },
);
